<template>
  <el-table-column
    prop="username"
    sortable
    label="Felhasználónév"
  >
    <template slot-scope="scope">
      {{ scope.row.username }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'username',
  };
</script>
